export default __webpack_public_path__ + "static/media/2.7aa09cae.svg";